import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { setCookie } from "../../custom_utils/cookies";
import { PREF_BRANCH_COOKIE_TOAST } from "./Localization/LocalizationState";
const TOAST_DISPLAY_TIME = 4500;
export class Toast extends React.Component {
    componentDidMount() {
        this.setState({
            ...this.state,
            show: this.props.show
        }, ()=>{
            const el = document.querySelector('#js--lt-toast');
            if (el == null) return;
            setTimeout(()=>{
                el.classList.add('show');
                el.classList.add('animate');
                setTimeout(()=>{
                    this.setState({
                        ...this.state,
                        show: 'false'
                    });
                    setCookie(PREF_BRANCH_COOKIE_TOAST, 'false', 1);
                    el.classList.remove('show');
                }, TOAST_DISPLAY_TIME);
            }, 100);
        });
    }
    componentWillUnmount() {
        setCookie(PREF_BRANCH_COOKIE_TOAST, 'false', 1);
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            id: "js--lt-toast",
            className: "location-toast lt",
            children: /*#__PURE__*/ _jsx("div", {
                className: "lt__inner container-fluid ",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "lt__message",
                    children: "Voorkeur opgeslagen"
                })
            })
        });
    }
    constructor(props, context){
        super(props, context);
        this.state = {
            show: 'false'
        };
    }
}
